export enum AppToolbarFormFields {
  UserQuery = 'userQuery',
}
